import React from 'react'
import {Modal, Button} from 'react-bootstrap'

interface FoodItem {
  id: number
  title: string
  description: string
  image: string
}

interface FoodItemsModalProps {
  show: boolean
  onHide: () => void
  foodItems: any[]
  selectedItems?: any[]
  onSelectItem: (id: any) => void
}

const FoodItemsModal: React.FC<FoodItemsModalProps> = ({
  show,
  onHide,
  foodItems,
  selectedItems,
  onSelectItem,
}) => {
  console.log('selected items', selectedItems)
  return (
    <Modal show={show} onHide={onHide} size='lg' centered>
      <Modal.Header closeButton>
        <Modal.Title>Available Food Items</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {foodItems.length === 0 ? (
          <p>No food items available.</p>
        ) : (
          <div className='d-flex flex-column gap-3'>
            {foodItems.map((item) => (
              <div key={item.id} className='card flex-row' style={{height: '120px'}}>
                <img
                  src={item?.featuredMedia?.path}
                  alt={item.title}
                  className='img-fluid rounded-start'
                  style={{
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                  }}
                />
                <div className='card-body'>
                  <h5 className='card-title'>{item.title}</h5>
                  <p className='card-text'>{item.description}</p>
                </div>
                <div className='form-check d-flex align-items-center ms-auto pe-3'>
                  <input
                    className='form-check-input'
                    type='radio'
                    id={`food-${item?.id}`}
                    checked={selectedItems?.includes(item.id)}
                    onClick={() => {
                      onSelectItem(item.id)
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className='btn btn-sm btn-light-primary' onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default FoodItemsModal
